/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsGetPublishStatus } from "../funcs/pluginsGetPublishStatus.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { PublishStatusResult } from "../models/components/publishstatusresult.js";
import {
  GetPublishStatusRequest,
  GetPublishStatusSecurity,
} from "../models/operations/getpublishstatus.js";
import { unwrapAsync } from "../types/fp.js";
export type PublishStatusQueryData = PublishStatusResult;

export function prefetchPublishStatus(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetPublishStatusRequest | undefined,
  security?: GetPublishStatusSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildPublishStatusQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildPublishStatusQuery(
  client$: GramCore,
  request?: GetPublishStatusRequest | undefined,
  security?: GetPublishStatusSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<PublishStatusQueryData>;
} {
  return {
    queryKey: queryKeyPublishStatus({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function publishStatusQueryFn(
      ctx,
    ): Promise<PublishStatusQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(pluginsGetPublishStatus(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyPublishStatus(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "plugins", "getPublishStatus", parameters];
}
